import { render, staticRenderFns } from "./ContactCaptcha.vue?vue&type=template&id=80d8d6ca&scoped=true"
import script from "./ContactCaptcha.vue?vue&type=script&lang=ts"
export * from "./ContactCaptcha.vue?vue&type=script&lang=ts"
import style0 from "./ContactCaptcha.vue?vue&type=style&index=0&id=80d8d6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d8d6ca",
  null
  
)

export default component.exports